import React from "react";

const INDUSTRIES = [
  "Restaurants",
  "Gyms & Fitness Centers",
  "Office Buildings",
  "Retail Stores",
  "Medical Facilities",
  "Schools & Daycares",
  "Apartment Complexes",
];

const Industries = () => {
  // Duplicate for seamless loop
  const items = [...INDUSTRIES, ...INDUSTRIES];

  return (
    <section
      id="industries"
      data-testid="industries-section"
      className="relative overflow-hidden border-y border-slate-200 bg-slate-50 py-20 md:py-28"
    >
      <div className="mx-auto max-w-7xl px-6 md:px-12">
        <div className="mb-12 max-w-3xl">
          <p className="mb-6 font-body text-xs font-semibold uppercase tracking-[0.22em] text-blue-600">
            — Who We Serve
          </p>
          <h2
            data-testid="industries-heading"
            className="font-heading text-3xl font-extrabold tracking-tight text-slate-900 sm:text-4xl lg:text-5xl"
          >
            Industries we keep spotless.
          </h2>
        </div>
      </div>

      <div className="relative w-full overflow-hidden">
        <div className="marquee-track flex w-max items-center gap-32 whitespace-nowrap py-6">
          {items.map((label, idx) => (
            <div
              key={`${label}-${idx}`}
              data-testid={`industry-${idx}`}
              className="flex items-center gap-32"
            >
              <span className="font-heading text-5xl font-black tracking-tighter text-slate-900 md:text-7xl lg:text-8xl">
                {label}
              </span>
              <span className="text-5xl text-blue-600 md:text-7xl lg:text-8xl">
                ✦
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Industries;
